import React from 'react';
import * as LucideIcons from 'lucide-react';
import { getLucideComponentName } from '../../utils/categoryIcons';

function CategoryIconByName({ iconName, size = 24, color = 'currentColor' }) {
  const ComponentName = iconName ? getLucideComponentName(iconName) : null;
  const IconComponent = ComponentName && LucideIcons[ComponentName];
  if (!IconComponent) return null;
  return <IconComponent size={size} color={color} />;
}

export default CategoryIconByName;
